import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useApiStore } from '../hooks/ApiStoreContext';
import { useAuth } from '../hooks/AuthProvider';

function LoginModel() {
    const apiStore = useApiStore();
    const auth = useAuth();
    const [users, setUsers] = useState([]); // Store users for uniqueness validation

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        getValues,
    } = useForm({
        mode: "onBlur",
        defaultValues: {
            userId: 0,
            firstName: "",
            lastName: "",
            email: "",
            contact: "",
            loginId: "",
            password: "",
            roleId: "2",
            isActive: true,
        },
    });

    const {
        register: registerLogin,
        handleSubmit: handleSubmitLogin,
        formState: { errors: loginErrors },
        reset: resetLogin,
        setValue: setValueLogin,
    } = useForm({
        mode: "onBlur",
        defaultValues: {
            username: "",
            password: "",
        },
    });

    const {
        register: registerReset,
        handleSubmit: handleSubmitReset,
        formState: { errors: resetErrors },
        reset: resetReset,
        setValue: setValueReset,
    } = useForm({
        mode: "onBlur",
        defaultValues: {
            username: "",
        },
    });

    // Fetch users for uniqueness validation
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await apiStore.get("/Users");
                setUsers(response);
            } catch (error) {
                console.error("Error fetching users:", error);
                Swal.fire({ icon: "error", title: "Error", text: "Failed to load users data." });
            }
        };
        fetchUsers();
    }, [apiStore]);

    // Uniqueness validation functions
    const validateEmail = (email) => {
        if (!email) return true;
        const exists = users.some((user) => user.email.toLowerCase() === email.toLowerCase());
        return !exists || "Email is already taken.";
    };

    const validateContact = (contact) => {
        if (!contact) return true;
        const exists = users.some((user) => user.contact === contact);
        return !exists || "Contact number is already taken.";
    };

    const validateLoginId = (loginId) => {
        if (!loginId) return true;
        const exists = users.some((user) => user.loginId.toLowerCase() === loginId.toLowerCase());
        return !exists || "Login Id is already taken.";
    };

    const onRegisterSubmit = async (data) => {
        console.log(data);
        try {
          //const response = await axios.post(`${apiBaseUrl}/Users/RegisterClient`, data);
          await apiStore.post('/Users/RegisterClient',data);
          hideModal('register');
          resetRegister();
          await Swal.fire({ title: "Success", text: "User registered successfully! Please Login.", icon: "success", confirmButtonText: "OK" });
          showModal('login');
        } catch (error) {
            console.error("There was an error registering user!", error);
            let errorMessage = "There was an error registering the user.";
            if (error.response?.data?.detail) {
                errorMessage = error.response.data.detail;
            }
            await Swal.fire({ icon: "error", title: "Error", text: errorMessage });
        }
      };

    const resetRegister = () => {
        reset({
            userId: 0,
            firstName: "",
            lastName: "",
            email: "",
            contact: "",
            loginId: "",
            password: "",
            roleId: "2",
            isActive: true,
        });
      };

    const onLoginSubmit = async (data) => {
        const resp = await auth.loginAction({ username: data.username, password: data.password });
        if (resp.status !== 200) {
            await Swal.fire({ title: "Login failed!", text: "Invalid login credentials.", icon: "warning", confirmButtonText: "OK" });
            return;
        }
        hideModal('login');
        resetLoginModal();
    };

    const resetLoginModal = () => {
        resetLogin({
            username: "",
            password: "",
        });
    };

    const onResetPassword = async (data) => {
        try {
            await apiStore.post('/auth/reset-password', { username: data.username });
            await Swal.fire({ title: "Success", text: "A password reset link has been sent.", icon: "success", confirmButtonText: "OK" });
            hideModal('forgotPassword');
            resetResetModal();
            showModal('login');
        } catch (error) {
            console.error("Error resetting password:", error);
            let errorMessage = "There was an error sending the reset link.";
            if (error.response?.data?.detail) {
                errorMessage = error.response.data.detail;
            }
            await Swal.fire({ icon: "error", title: "Error", text: errorMessage });
        }
    };

    const resetResetModal = () => {
        resetReset({
            username: "",
        });
    };

    const hideModal = (modalName) => {
        let modal = document.getElementById(modalName);
        if (modal) {
            var modalInstance = window.bootstrap.Modal.getInstance(modal);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
    };

    const showModal = (modalName) => {
        let modal = document.getElementById(modalName);
        if (modal) {
            var modalInstance = window.bootstrap.Modal.getInstance(modal);
            if (modalInstance) {
                modalInstance.show();
            }
        }
    };

    return (
        <>
            <div className="modal modalCentered fade form-sign-in modal-part-content" id="login">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="header">
                            <div className="demo-title">Log in</div>
                            <span className="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
                        </div>
                        <div className="tf-login-form">
                            <form onSubmit={handleSubmitLogin(onLoginSubmit)}>
                                <div className="tf-field style-1">
                                    <input
                                        className="tf-field-input tf-input"
                                        placeholder=" "
                                        type="text"
                                        id="txtLoginId"
                                        {...registerLogin("username", {
                                            required: "Login Id is required.",
                                            pattern: {
                                                value: /^[a-zA-Z0-9._%+-@]+|[0-9]{10}$/,
                                                message: "Please enter a valid Login ID, Email, or 10-digit Contact number.",
                                            },
                                        })}
                                    />
                                    <label className="tf-field-label" htmlFor="txtLoginId">Login Id *</label>
                                    <span className="text-xs text-danger">{loginErrors.username?.message}</span>
                                </div>
                                <div className="tf-field style-1">
                                    <input
                                        className="tf-field-input tf-input"
                                        placeholder=" "
                                        type="password"
                                        id="txtPassword"
                                        {...registerLogin("password", { required: "Password is required." })}
                                    />
                                    <label className="tf-field-label" htmlFor="txtPassword">Password *</label>
                                    <span className="text-xs text-danger">{loginErrors.password?.message}</span>
                                </div>
                                <div>
                                    <a href="#forgotPassword" data-bs-toggle="modal" className="btn-link link">Forgot your password?</a>
                                </div>
                                <div className="bottom">
                                    <div className="w-100">
                                        <button type="submit" className="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"><span>Log in</span></button>
                                    </div>
                                    <div className="w-100">
                                        <a href="#register" data-bs-toggle="modal" className="btn-link fw-6 w-100 link">
                                            New customer? Create your account
                                            <i className="icon icon-arrow1-top-left"></i>
                                        </a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal modalCentered fade form-sign-in modal-part-content" id="forgotPassword">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="header">
                            <div className="demo-title">Reset your password</div>
                            <span className="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
                        </div>
                        <div className="tf-login-form">
                            <form onSubmit={handleSubmitReset(onResetPassword)}>
                                <div>
                                    <p>We will send a password reset link to your registered email.</p>
                                </div>
                                <div className="tf-field style-1">
                                    <input
                                        className="tf-field-input tf-input"
                                        placeholder=" "
                                        type="text"
                                        id="txtResetLoginId"
                                        {...registerReset("username", {
                                            required: "Login Id is required.",
                                            pattern: {
                                                value: /^[a-zA-Z0-9._%+-@]+|[0-9]{10}$/,
                                                message: "Please enter a valid Login ID, Email, or 10-digit Contact number.",
                                            },
                                        })}
                                    />
                                    <label className="tf-field-label" htmlFor="txtResetLoginId">Login Id *</label>
                                    <span className="text-xs text-danger">{resetErrors.username?.message}</span>
                                </div>
                                <div>
                                    <a href="#login" data-bs-toggle="modal" className="btn-link link">Cancel</a>
                                </div>
                                <div className="bottom">
                                    <div className="w-100">
                                        <button type="submit" className="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"><span>Reset password</span></button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal modalCentered fade form-sign-in modal-part-content" id="register">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="header">
                            <div className="demo-title">Register</div>
                            <span className="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
                        </div>
                        <div className="tf-login-form">
                            <form onSubmit={handleSubmit(onRegisterSubmit)}>
                                <div className="tf-field style-1">
                                    <input
                                        className="tf-field-input tf-input"
                                        placeholder=" "
                                        type="text"
                                        id="txtFirstName"
                                        {...register("firstName", { required: "Company name is required." })}
                                    />
                                    <label className="tf-field-label" htmlFor="txtFirstName">Company *</label>
                                    <span className="text-xs text-danger">{errors.firstName?.message}</span>
                                </div>
                                <div className="tf-field style-1">
                                    <input
                                        className="tf-field-input tf-input"
                                        placeholder=" "
                                        type="text"
                                        id="txtLastName"
                                        {...register("lastName", { required: "Contact person name is required." })}
                                    />
                                    <label className="tf-field-label" htmlFor="txtLastName">Contact person name *</label>
                                    <span className="text-xs text-danger">{errors.lastName?.message}</span>
                                </div>
                                <div className="tf-field style-1">
                                    <input
                                        className="tf-field-input tf-input"
                                        placeholder=" "
                                        type="text"
                                        id="txtLoginId"
                                        {...register("loginId", {
                                            required: "Login Id is required.",
                                            minLength: { value: 6, message: "Login ID must be at least 6 characters." },
                                            maxLength: { value: 255, message: "Maximum 255 characters allowed." },
                                            pattern: {
                                                value: /^[a-zA-Z0-9_-]+$/,
                                                message: "Login Id can only contain letters, numbers, underscores, or hyphens.",
                                            },
                                            validate: validateLoginId,
                                        })}
                                    />
                                    <label className="tf-field-label" htmlFor="txtLoginId">Login Id *</label>
                                    <span className="text-xs text-danger">{errors.loginId?.message}</span>
                                </div>
                                <div className="tf-field style-1">
                                    <input
                                        className="tf-field-input tf-input"
                                        placeholder=" "
                                        type="email"
                                        id="txtEmail"
                                        {...register("email", {
                                            required: "Email is required.",
                                            pattern: {
                                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                message: "Please enter a valid email address.",
                                            },
                                            validate: validateEmail,
                                        })}
                                    />
                                    <label className="tf-field-label" htmlFor="txtEmail">Email *</label>
                                    <span className="text-xs text-danger">{errors.email?.message}</span>
                                </div>
                                <div className="tf-field style-1">
                                    <input
                                        className="tf-field-input tf-input"
                                        placeholder=" "
                                        type="tel"
                                        id="txtContact"
                                        {...register("contact", {
                                            required: "Contact number is required.",
                                            pattern: { value: /^\d{10}$/, message: "Please enter a valid 10-digit contact number." },
                                            validate: validateContact,
                                        })}
                                    />
                                    <label className="tf-field-label" htmlFor="txtContact">Contact Number *</label>
                                    <span className="text-xs text-danger">{errors.contact?.message}</span>
                                </div>
                                <div className="tf-field style-1">
                                    <input
                                        className="tf-field-input tf-input"
                                        placeholder=" "
                                        type="password"
                                        id="txtPassword"
                                        {...register("password", {
                                            required: "Password is required.",
                                            minLength: { value: 8, message: "Password should be minimum 8 characters in length." },
                                        })}
                                    />
                                    <label className="tf-field-label" htmlFor="txtPassword">Password *</label>
                                    <span className="text-xs text-danger">{errors.password?.message}</span>
                                </div>
                                <div className="bottom">
                                    <div className="w-100">
                                        <button type="submit" className="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center">Register</button>
                                    </div>
                                    <div className="w-100">
                                        <a href="#login" data-bs-toggle="modal" className="btn-link fw-6 w-100 link">
                                            Already have an account? Log in here
                                            <i className="icon icon-arrow1-top-left"></i>
                                        </a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LoginModel;